import { useLanguage } from "@/lib/LanguageContext";
import { useReveal } from "@/lib/useReveal";

export default function Process() {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative px-6 sm:px-12 lg:px-24 py-24 sm:py-32 bg-[#0D0E13] border-y border-white/5"
    >
      <div ref={ref} className="reveal max-w-3xl mb-20">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D97736] mb-4">
          {t.process.overline}
        </p>
        <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
          {t.process.title}
        </h2>
      </div>

      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7 lg:col-start-3">
          <ol className="relative border-l border-white/15 ml-3 lg:ml-6 pl-8 lg:pl-12 space-y-12">
            {t.process.steps.map((s, i) => (
              <li
                key={i}
                data-testid={`process-step-${i}`}
                className="group relative"
              >
                <span className="absolute -left-[42px] lg:-left-[60px] top-1 w-8 h-8 lg:w-10 lg:h-10 grid place-items-center bg-[#0B0C10] border border-white/20 text-[10px] lg:text-xs font-display font-black text-[#D97736] group-hover:bg-[#D97736] group-hover:text-[#0B0C10] group-hover:border-[#D97736] transition-all">
                  {s.n}
                </span>
                <h3 className="font-display font-bold text-white text-2xl sm:text-3xl mb-2 tracking-tight">
                  {s.t}
                </h3>
                <p className="text-[#A0AAB2] text-base leading-relaxed max-w-xl">
                  {s.d}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
